export enum EMessageType {
  Incoming = 'incoming',
  Outcoming = 'outcoming',
  Unread = 'unread',
}
